// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mHrY0lsbgt8FXp7VqRCP {\n  display: grid;\n  justify-content: center;\n}\n.iqwzuq5ch8mZfDL9EelM {\n  justify-self: center;\n}\n", "",{"version":3,"sources":["webpack://./src/components/mis-mascotas-cards/index.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB","sourcesContent":[".container {\n  display: grid;\n  justify-content: center;\n}\n.spinner {\n  justify-self: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "mHrY0lsbgt8FXp7VqRCP",
	"spinner": "iqwzuq5ch8mZfDL9EelM"
};
export default ___CSS_LOADER_EXPORT___;
